import { HashRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';

import Login from "./pages/Login";
import Exames from "./pages/Exames";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/exames" element={<Exames />} />
      </Routes>
    </Router>
  );
}

export default App;